import { Select, Space, Tabs } from "antd";
import styles from "./student-view-tabs.module.css";
import CustomButton from "../../../../common/custom-button/custom-button";
import SVGIcon from "../../../../constants/SVGIcon";
import AcademicView from "../academic-view/academic-view";
import { useState } from "react";
import BulkUpload from "../../../../components/bulk-upload/bulk-upload";
import { bulkUploadStudent } from "../../../../services/student";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import RoutesConstant from "../../../../constants/routes";
import AllStudentsList from "../all-students-tab/all-students-tab";
import CustomSelect from "../../../../common/input/custom-select/custom-select";
import { useAcademicYears } from "../../../../hooks/useAcademicYear";

export function StudentViewTabs() {
  const [showBulkUpload, setShowBulkUpload] = useState(false);
  const [error, setError] = useState([]);
  const navigate = useNavigate();
  const [triggerRefetch, setTriggerRefetch] = useState(0);
  const {
    yearList,
    selectedYear,
    selectedYearName,
    onChangeSelectedYear,
    onPopupScroll,
  } = useAcademicYears();

  const handleAddStudent = () => {
    navigate(RoutesConstant.STUDENT_FORM);
  };

  const items = [
    {
      key: "1",
      label: "Active",
      children: (
        <AllStudentsList
          triggerRefetch={triggerRefetch}
          isActive={true}
          selectedYear={selectedYear}
        />
      ),
    },
    {
      key: "2",
      label: "Suspend",
      children: (
        <AllStudentsList
          triggerRefetch={triggerRefetch}
          isActive={false}
          selectedYear={selectedYear}
        />
      ),
    },
    {
      key: "3",
      label: "Academic View",
      children: (
        <AcademicView
          triggerRefetch={triggerRefetch}
          selectedYear={selectedYear}
          selectedYearName={selectedYearName}
        />
      ),
    },
  ];

  const operations = (
    <div className={styles.action_container}>
      <CustomSelect
        className={styles.selectField}
        placeholder="Select Year"
        value={selectedYear}
        onChange={(value) => onChangeSelectedYear(value)}
        onPopupScroll={onPopupScroll}
      >
        {yearList.map((item, index) => (
          <Select.Option key={item?.id || index} value={item?.id}>
            {item?.name}
          </Select.Option>
        ))}
      </CustomSelect>
      <Space
        direction="horizontal"
        wrap
        style={{ justifyContent: "center", display: "flex", width: "100%" }}
      >
        <CustomButton
          title="Add Student"
          size="large"
          icon={
            <SVGIcon
              name="add-icon"
              width="24"
              height="24"
              className="anticon"
              stroke="#FFF"
            />
          }
          onClick={handleAddStudent}
        />
        <CustomButton
          title="Bulk Upload"
          size="large"
          icon={
            <SVGIcon
              name="upload"
              width="24"
              height="24"
              className="anticon"
              stroke="#FFF"
            />
          }
          onClick={() => setShowBulkUpload(!showBulkUpload)}
        />
      </Space>
    </div>
  );

  const handleBulkUpload = async (file, classroom_id, academic_year_id) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("classroom_id", classroom_id);
      formData.append("academic_year_id", academic_year_id);
      const resp = await bulkUploadStudent(formData);
      
      if (resp?.data?.errorCode === "PARTIAL_SUCCESS") {
        setError(resp?.data?.data?.errors);
        toast.warning(resp?.data?.message || "Student Creations is Partially Successful");
      } else {
        setError([]);
        setShowBulkUpload(false);
        toast.success(resp?.data?.message || "Student Creations is Successful");
      }
      setTriggerRefetch((prev) => prev + 1);
    } catch (err) {
      setError([]);
      toast.error(err?.data?.message || "Something error occurred");
    }
  };

  const handleCloseBulkUpload = () => {
    setShowBulkUpload(!showBulkUpload);
    setError([]);
  };

  return (
    <div className={styles.student_view_tabs}>
      <>
        <div className={styles.tab_actions_mobile}>{operations}</div>

        <Tabs
          defaultActiveKey="1"
          items={items}
          tabBarStyle={{ borderBottom: "none" }}
          tabBarExtraContent={
            <div className={styles.tab_actions_desktop}>{operations}</div>
          }
        />
      </>

      <BulkUpload
        open={showBulkUpload}
        errors={error}
        accepts=".xlsx"
        onClose={handleCloseBulkUpload}
        handleClickUpload={handleBulkUpload}
        isStudentPage={true}
      />
    </div>
  );
}

export default StudentViewTabs;
